import store from "@/store";
import {
  httpSuccessResponseLogger,
  httpErrorResponseLogger
} from "@/helpers/logger";
import { redirectToProperErrorPage } from "@/helpers/router";

let isLoading = false;
export default function({ next, to, router }) {
  if (isLoading) {
    return next();
  }

  isLoading = true;

  store
    .dispatch("providers/projectAddons/getData")
    .then(response => {
      httpSuccessResponseLogger(response);
      isLoading = false;
      return next();
    })
    .catch(error => {
      httpErrorResponseLogger(error);
      isLoading = false;
      redirectToProperErrorPage(error, to, router);
    });
}
